import { GroupNames, UserGroup } from '../sharedComponents/src/globalHeader/GlobalHeader'

export const isGuest = (userGroups?: UserGroup[]) => userGroups?.some((group: any) => group.name === GroupNames.GUEST)
